import { API, CHECKOUT_STATE_API_TIMEOUT, CHECKOUT_STATE_URL, REQUEST_METHOD } from '../config.js';
import { fetchWithTimeout } from './http-client.js';

const httpMethod = async (url, cartVersion, method, body, csrfToken) => {
    return await fetchWithTimeout(`${CHECKOUT_STATE_URL}${cartVersion ? `/${cartVersion}` : ''}${url}`, CHECKOUT_STATE_API_TIMEOUT, {
        method,
        body: body ? JSON.stringify(body) : undefined,
    }, csrfToken);
};
const query = {
    getCartApiVersion: async () => await httpMethod(API.GET_CART_VERSION),
    getState: async (cartVersion) => await httpMethod(API.GET, cartVersion),
    setSavingsPlanArticle: async (body, cartVersion) => await httpMethod(API.SET_SAVING_PLAN_ARTICLE, cartVersion, REQUEST_METHOD.PUT, body),
    setCoupon: async (body, cartVersion) => await httpMethod(API.SET_COUPON, cartVersion, REQUEST_METHOD.PATCH, body),
    deleteCoupon: async (body, cartVersion) => await httpMethod(API.DELETE_COUPON, cartVersion, REQUEST_METHOD.DELETE, body),
    setFreeSampleArticle: async (body, cartVersion) => await httpMethod(API.SET_SAMPLE_ARTICLE, cartVersion, REQUEST_METHOD.PUT, body),
    setArticleQuantity: async (body, cartVersion) => await httpMethod(API.SET_ARTICLE_QUANTITY, cartVersion, REQUEST_METHOD.PUT, body),
    setShippingCountry: async ({ country, zipCode }, cartVersion) => await httpMethod(`${API.SET_SHIPPING_COUNTRY}/${country}${zipCode && `/${zipCode}`}`, cartVersion, REQUEST_METHOD.PUT),
    setSubscriptionInterval: async ({ subscriptionInterval }, cartVersion) => await httpMethod(`${API.SET_SUBSCRIPTION_INTERVAL}/${subscriptionInterval}`, cartVersion, REQUEST_METHOD.PATCH),
    removeSubscription: async (cartVersion) => await httpMethod(API.REMOVE_SUBSCRIPTION, cartVersion, REQUEST_METHOD.DELETE),
    createBasicGuestAccount: async (body, csrfToken, cartVersion) => await httpMethod(API.CREATE_BASIC_GUEST_ACCOUNT, cartVersion, REQUEST_METHOD.POST, body, csrfToken),
    updateGuestAccountEmail: async (body, cartVersion) => await httpMethod(API.UPADTE_GUEST_ACCOUNT_EMAIL, cartVersion, REQUEST_METHOD.PATCH, body),
    setAddresses: async (body, cartVersion) => await httpMethod(API.SET_ADDRESSES, cartVersion, REQUEST_METHOD.PUT, body),
    deleteSavedCard: async (body, cartVersion) => {
        const apiUrl = API.DELETE_SAVED_CARD.replace('{pspIdentifier}', body.pspIdentifier).replace('{psp}', body.psp);
        return await httpMethod(apiUrl, cartVersion, REQUEST_METHOD.DELETE, body);
    },
    deleteSavedBancontact: async (body, cartVersion) => {
        const apiUrl = API.DELETE_SAVED_BANCONTACT.replace('{bancontactIdentifier}', body.bancontactIdentifier);
        return await httpMethod(apiUrl, cartVersion, REQUEST_METHOD.DELETE, body);
    },
    updatePreferredPayment: async (body, cartVersion) => await httpMethod(API.UPDATE_PREFERRED_PAYMENT, cartVersion, REQUEST_METHOD.PATCH, body),
    setDeliveryService: async (body, cartVersion) => await httpMethod(API.SET_DELIVERY_SERVICE, cartVersion, REQUEST_METHOD.PATCH, body),
};

export { httpMethod, query };
//# sourceMappingURL=http-methods.js.map
